import request from '@/utils/request'

/**
 * 查询出入库订单列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryInoutOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/queryInoutOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}